// shadcn/ui component: https://ui.shadcn.com/docs/components/radix/skeleton
import React from 'react';

import { cn } from 'src/component/ds/utils';

/**
 * shadcn/ui's Skeleton: a pulsing block standing in for content that hasn't
 * loaded. Give it the size of whatever it replaces.
 *
 * @param {React.HTMLAttributes<HTMLDivElement>} props `className` sizes the
 *   block; the rest spread onto the div
 * @returns {JSX.Element} the placeholder block
 */
function Skeleton ({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      data-slot='skeleton'
      className={cn('ds-animate-pulse ds-rounded ds-bg-accent', className)}
      {...props}
    />
  );
}

export { Skeleton };
